import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Form, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { WizardSteps } from '../../components'
import { useStateValue } from '@State'
import { linkPaths, COURSENUM } from '../urls'
import { CertHeader } from './CertHeader'
import { CertPreamble } from './CertPreamble'
import { CertReason } from './CertReason'
import { CertAward } from './CertAward'
import { CertImage } from './CertImage'

export const Design = () => {
  const [state, dispatch] = useStateValue()
  const history = useHistory()

  const goBack = e => {
    e.preventDefault()
    window.location = `/instructor/achievements/${COURSENUM}/`
  }

  const goNext = e => {
    e.preventDefault()
    history.push(linkPaths.requirements)
  }

  const imageTooltip = (
    <Tooltip id="image_tooltip">
      Image will be cropped to 250x50
      <br />
      Image can be 1 MB or less
    </Tooltip>
  )

  const needsRequirements = !state.certInfo.header || !state.certInfo.award

  return (
    <div>
      <WizardSteps
        edit={state.certInfo.retrievedEditData}
        linkPaths={linkPaths}
        step={1}
        heading="Certificate"
        subHeading="Build Certificate"
        annotation="Click an item to edit the content"
      />
      <div id="outer_certificate">
        <div id="inner_certificate">
          <CertHeader />
          <CertPreamble />
          <div className="text-center" id="user_name">
            Taylor Smith
          </div>
          <CertReason />
          <CertAward />
          <div className="image_and_date">
            <div className="image_date" id="image">
              <OverlayTrigger placement="right" overlay={imageTooltip}>
                <span>Seal Image</span>
              </OverlayTrigger>
              <CertImage />
            </div>
            <div className="image_date" id="date">
              (Date Awarded)
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ marginLeft: '20%', marginRight: '20%', marginTop: '15px' }}
      >
        <Form.Group controlId="descriptionID">
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            onChange={e =>
              dispatch({
                type: 'UPDATE_CERT_INFO',
                payload: { description: e.target.value },
              })
            }
            value={state.certInfo.description}
          />
        </Form.Group>
      </div>
      <div className="btn_container">
        <Button variant="primary" onClick={goBack}>
          Back
        </Button>
        <Button
          variant="primary"
          disabled={needsRequirements}
          onClick={goNext}
        >
          Next
        </Button>
      </div>
    </div>
  )
}
